define('router/router-tasks/initialize-gsu',['require','lib/check-first-visit','api-access','durandal/app'],function (require) {
    var checkFirstVisit = require('lib/check-first-visit');
    var userApi = require('api-access').user;
    var app = require('durandal/app');

    return function () {
        // Initialize the GSU V2 feature only for the new users
        checkFirstVisit.check().then(function (isFirstLogin) {
            if (isFirstLogin) {
                userApi.updateSettings({
                    hasCompletedGSU: false,
                    hasScheduledMeeting: false,
                    hasStartedMeeting: false,
                    hasExploredAudioOptions: false,
                    hasIntegratedCalendar: false,
                    isGSUPopoverShown: false,
                    isGSUEnabled: true
                }).then(function () {
                    app.trigger('GSU:Enabled');
                });
            }
        });
    };
});

